module.exports = __webpack_public_path__ + "media/images/socean-349a45ab.png";